"use client";

import { Trans, useLingui } from "@lingui/react/macro";
import { LinkButton } from "@offstreetparking/design-system/forms";
import { Link, Text } from "@offstreetparking/design-system/typography";
import { PRIVACY_URL, TERMS_URL } from "@offstreetparking/portal-flow/lib/legal-urls";
import { useState } from "react";
import { useKiosk } from "~/components/providers/KioskProvider";
import { LegalContentModal } from "./components/LegalContentModal";

export const Footer = () => {
	const { isKiosk } = useKiosk();
	const { t } = useLingui();
	const [tosOpen, setTosOpen] = useState(false);
	const [privacyOpen, setPrivacyOpen] = useState(false);
	const opensInNewTab = t`(opens in a new tab)`;
	const termsLabel = t`Terms of Service`;
	const privacyLabel = t`Privacy Policy`;

	return (
		<footer className="bottom-0 z-footer hidden w-full justify-between border-neutral-faded border-t bg-white px-8 py-4 text-sm md:flex print:hidden">
			<span>
				{!isKiosk ? (
					<Trans>
						Powered by{" "}
						<Link
							size="sm"
							href="https://joinoffstreet.com"
							isExternal
							intent="secondary"
							aria-label={`Offstreet ${opensInNewTab}`}
						>
							Offstreet
						</Link>
						.
					</Trans>
				) : (
					<Text As="span" size="sm">
						{t`Powered by Offstreet`}
					</Text>
				)}
			</span>

			{isKiosk ? (
				<>
					<div className="flex gap-8">
						<LinkButton type="button" size="sm" onClick={() => setTosOpen(true)} intent="secondary">
							{termsLabel}
						</LinkButton>
						<LinkButton type="button" size="sm" onClick={() => setPrivacyOpen(true)} intent="secondary">
							{privacyLabel}
						</LinkButton>
					</div>
					<LegalContentModal
						isOpen={tosOpen}
						onClose={() => setTosOpen(false)}
						title={termsLabel}
						url={TERMS_URL}
					/>
					<LegalContentModal
						isOpen={privacyOpen}
						onClose={() => setPrivacyOpen(false)}
						title={privacyLabel}
						url={PRIVACY_URL}
					/>
				</>
			) : (
				<div className="flex gap-8">
					<Link
						size="sm"
						href={TERMS_URL}
						isExternal
						intent="secondary"
						aria-label={`${termsLabel} ${opensInNewTab}`}
					>
						{termsLabel}
					</Link>
					<Link
						isExternal
						size="sm"
						href={PRIVACY_URL}
						intent="secondary"
						aria-label={`${privacyLabel} ${opensInNewTab}`}
					>
						{privacyLabel}
					</Link>
				</div>
			)}
		</footer>
	);
};
